import axios, { AxiosHeaderValue } from "axios";
import { useEffect, useState } from "react";
import beaconResultType from "../model/beaconResultType";
import { Button, Col, Form, Row } from "react-bootstrap";
import Result from "../components/BeaconLogResult";
import SensorLog_iBS02IR_Result from "../components/SensorLog_iBS02IR_Result";
import Header from "../components/Header";
import PageSelect from "../components/PageSelect";
import BeaconModel from "../model/BeaconModel";
import ExcelJS from 'exceljs';
import Loading from "../components/Loading";
import "react-datepicker/dist/react-datepicker.css";
import iBS02IR_ResultType from "../model/iBS02IR_ResultType";
import iBS02PIR_ResultType from "../model/iBS02PIR_ResultType";
import iBS03R_ResultType from "../model/iBS03R_ResultType";
import iBS03T_ResultType from "../model/iBS03T_ResultType";
import iBS05H_ResultType from "../model/iBS05H_ResultType";
import SensorLog_iBS02PIR_Result from "../components/SensorLog_iBS02PIR_Result";
import SensorLog_iBS03R_Result from "../components/SensorLog_iBS03R_Result";
import SensorLog_iBS03T_Result from "../components/SensorLog_iBS03T_Result";
import SensorLog_iBS05H_Result from "../components/SensorLog_iBS05H_Result";

const SensorLog = () => {

    const [apiKey, setApikey] = useState<string>("");
    const [model, setModel] = useState<string>("");
    const [per_page, setPer_Page] = useState<string>("1000");
    const [macaddress, setMacaddress] = useState<string>("");
    const [rssi_gt, setRssi_gt] = useState<string>("");
    const [rssi_lt, setRssi_lt] = useState<string>("");
    const [detected_gt, setDetcted_gt] = useState<string>("");
    const [detected_lt, setDetcted_lt] = useState<string>("");
    const [arrived_gt, setArrived_gt] = useState<string>("");
    const [arrived_lt, setArrived_lt] = useState<string>("");
    const [sort, setSort] = useState<string>("");
    const [pageNo, setPageNo] = useState<number>(0);
    const [lastPageNo, setLastPageNo] = useState<number>(0);
    const [total, setTotal] = useState<number>(-1);

    const [iBS02IRResult, setIBS02IRResult] = useState<iBS02IR_ResultType[]>([]);
    const [iBS02PIRResult, setIBS02PIRResult] = useState<iBS02PIR_ResultType[]>([]);
    const [iBS03RResult, setIBS03RResult] = useState<iBS03R_ResultType[]>([]);
    const [iBS03TResult, setIBS03TResult] = useState<iBS03T_ResultType[]>([]);
    const [iBS05HResult, setIBS05HResult] = useState<iBS05H_ResultType[]>([]);

    const iBS02IRResults: iBS02IR_ResultType[] = [];
    const iBS02PIRResults: iBS02PIR_ResultType[] = [];
    const iBS03RResults: iBS03R_ResultType[] = [];
    const iBS03TResults: iBS03T_ResultType[] = [];
    const iBS05HResults: iBS05H_ResultType[] = [];

    const [iBS02IRCsvResult, setIBS02IRCsvResult] = useState<iBS02IR_ResultType[]>([]);
    const [iBS02PIRCsvResult, setIBS02PIRCsvResult] = useState<iBS02PIR_ResultType[]>([]);
    const [iBS03RCsvResult, setIBS03RCsvResult] = useState<iBS03R_ResultType[]>([]);
    const [iBS03TCsvResult, setIBS03TCsvResult] = useState<iBS03T_ResultType[]>([]);
    const [iBS05HCsvResult, setIBS05HCsvResult] = useState<iBS05H_ResultType[]>([]);


    const [beaconResult, setBeaconResult] = useState<BeaconModel[]>([]);
    const beaconResults: BeaconModel[] = [];

    const [isNoCheck, setNoCheck] = useState<boolean>(false);
    const [isNamaCheck, setNameCheck] = useState<boolean>(false);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    var apiUrl:string = "";
 
    const checkLocoEnv = () => {
      if (localStorage.getItem("locoEnv") === "prod") {
        apiUrl = "https://api.bc-loco.jp/api/v2/sensor_logs"
      } else {
        apiUrl = "http://stg.api.bc-loco.jp/api/v2/sensor_logs"
      }
    }
    
    const getSensorLogs = async(e: any, pageNo: number) => {
        e.preventDefault();

        // 各種Resultをクリア
        setIBS02IRResult([]);
        setIBS02PIRResult([]);
        setIBS03RResult([]);
        setIBS03TResult([]);
        setIBS05HResult([]);

        if (per_page === "") {
          setPer_Page("1000")
        }
        saveParams();
        saveApikey();
        checkLocoEnv();

        await axios.get(apiUrl,
        {
          headers: {
              "Authorization": apiKey,
              "Content-Type": "application/json"
          },
          params: {
              ...(pageNo ? {page: pageNo} : {}),
              ...(per_page ? {per_page: per_page} : {}),
              ...(model ? {model: model} : {}),
              ...(macaddress ? {macaddress: macaddress} : {}),
              ...(rssi_gt ? {rssi_gt: rssi_gt} : {}),
              ...(rssi_lt ? {rssi_lt: rssi_lt} : {}),
              ...(detected_gt ? {detected_gt: detected_gt.replace("T", " ")} : {}),
              ...(detected_lt ? {detected_lt: detected_lt.replace("T", " ")} : {}),
              ...(arrived_gt ? {arrived_gt: arrived_gt.replace("T", " ")} : {}),
              ...(arrived_lt ? {arrived_lt: arrived_lt.replace("T", " ")} : {}),
              ...(sort ? {sort: sort} : {})
          }
        })
        .then(async res => {
          console.log(res);
          if(res.data.code === 400) {
            alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
            return 
          } else if(res.data.code === 401) {
            alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
            return 
          } 

          const items = JSON.parse(JSON.stringify(res.data.payload))
          if (items.total > 100000) {
            if (pageNo === 0) {
              alert("10万件を超えるデータは表示出来ません\n10万件までのデータを表示します\n総件数:" + items.total + "\n日付範囲を調整して下さい。")
            }
            setTotal(items.total)
            setPageNo(items.current_page)
            setLastPageNo(getLastPageNo())
          } else {
            setTotal(items.total)
            setPageNo(items.current_page)
            setLastPageNo(items.last_page)
          }

          // モデルごとに型を分岐
          switch(model) {
            case "iBS02IR":
              const irResults: iBS02IR_ResultType[] = [];
              items.data.forEach((value: iBS02IR_ResultType, index: number) => {
                value.no = items.from;
                items.from++;
                irResults.push(value);
              });
              setIBS02IRResult(irResults);
              break;
            case "iBS02PIR":
              const pirResults: iBS02PIR_ResultType[] = [];
              items.data.forEach((value: iBS02PIR_ResultType, index: number) => {
                value.no = items.from;
                items.from++;
                pirResults.push(value);
              });
              setIBS02PIRResult(pirResults);
              break;
            case "iBS03R":
              const rResults: iBS03R_ResultType[] = [];
              items.data.forEach((value: iBS03R_ResultType, index: number) => {
                value.no = items.from;
                items.from++;
                rResults.push(value);
              });
              setIBS03RResult(rResults);
              break;
            case "iBS03T":
              const tResults: iBS03T_ResultType[] = [];
              items.data.forEach((value: iBS03T_ResultType, index: number) => {
                value.no = items.from;
                items.from++;
                tResults.push(value);
              });
              setIBS03TResult(tResults);
              break;
            case "iBS05H":
              const hResults: iBS05H_ResultType[] = [];
              items.data.forEach((value: iBS05H_ResultType, index: number) => {
                value.no = items.from;
                items.from++;
                hResults.push(value);
              });
              setIBS05HResult(hResults);
              break;
            default:
              // 共通型や他モデルの場合
                alert("モデルを選択して下さい")
          }
        })
        .catch(err => 
          alert("エラーが発生しました。" + err)
        )
    }

    // model値に応じてCSV用Result配列を返す関数
    const getCsvResultArray = () => {
      switch(model) {
        case "iBS02IR":
          return iBS02IRCsvResult;
        case "iBS02PIR":
          return iBS02PIRCsvResult;
        case "iBS03R":
          return iBS03RCsvResult;
        case "iBS03T":
          return iBS03TCsvResult;
        case "iBS05H":
          return iBS05HCsvResult;
        default:
          return []; // 共通型や未選択時
      }
    };
    // model値に応じてset関数を返す関数
    const getSetCsvResult = (): React.Dispatch<React.SetStateAction<any[]>> => {
      switch(model) {
        case "iBS02IR":
          return setIBS02IRCsvResult as React.Dispatch<React.SetStateAction<any[]>>;
        case "iBS02PIR":
          return setIBS02PIRCsvResult as React.Dispatch<React.SetStateAction<any[]>>;
        case "iBS03R":
          return setIBS03RCsvResult as React.Dispatch<React.SetStateAction<any[]>>;
        case "iBS03T":
          return setIBS03TCsvResult as React.Dispatch<React.SetStateAction<any[]>>;
        case "iBS05H":
          return setIBS05HCsvResult as React.Dispatch<React.SetStateAction<any[]>>;
        default:
          return (() => {}) as React.Dispatch<React.SetStateAction<any[]>>;
      }
    };

    const createCSV = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet("beaconLog");
      const worksheet = workbook.getWorksheet("beaconLog");

      

      // モデルごとにヘッダーを定義
      let columns: Partial<ExcelJS.Column>[] = [];
      switch(model) {
        case "iBS02IR":
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "app_id", key: "app_id" },
            { header: "manufacturer_id", key: "manufacturer_id" },
            { header: "model", key: "model" },
            { header: "battery", key: "battery" },
            { header: "event", key: "event" },
            { header: "macaddress", key: "macaddress" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" }
          ];
          break;
        case "iBS02PIR":
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "app_id", key: "app_id" },
            { header: "manufacturer_id", key: "manufacturer_id" },
            { header: "model", key: "model" },
            { header: "battery", key: "battery" },
            { header: "event", key: "event" },
            { header: "macaddress", key: "macaddress" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" }
          ];
          break;
        case "iBS03R":
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "app_id", key: "app_id" },
            { header: "manufacturer_id", key: "manufacturer_id" },
            { header: "model", key: "model" },
            { header: "battery", key: "battery" },
            { header: "button", key: "button" },
            { header: "distance", key: "distance" },
            { header: "macaddress", key: "macaddress" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" }
          ];
          break;
        case "iBS03T":
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "app_id", key: "app_id" },
            { header: "manufacturer_id", key: "manufacturer_id" },
            { header: "model", key: "model" },
            { header: "battery", key: "battery" },
            { header: "button", key: "button" },
            { header: "moving", key: "moving" },
            { header: "hall_sensor", key: "hall_sensor" },
            { header: "temperature", key: "temperature" },
            { header: "humidity", key: "humidity" },
            { header: "macaddress", key: "macaddress" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" }
          ];
          break;
        case "iBS05H":
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "app_id", key: "app_id" },
            { header: "manufacturer_id", key: "manufacturer_id" },
            { header: "model", key: "model" },
            { header: "battery", key: "battery" },
            { header: "hall_sensor", key: "hall_sensor" },
            { header: "count", key: "count" },
            { header: "macaddress", key: "macaddress" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" }
          ];
          break;
        default:
          // 共通型や未選択時
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "id", key: "id" },
            { header: "bundle_id", key: "bundle_id" },
            { header: "device_id", key: "device_id" },
            { header: "beacon_id", key: "beacon_id" },
            { header: "name", key: "name" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" },
            { header: "latitude", key: "latitude" },
            { header: "longitude", key: "longitude" },
            { header: "abs_height", key: "abs_height" }
          ];
          break;
      }

      worksheet.columns = columns;

      setIsLoading(true);

      // modelごとにResult配列を取得
      const csvResult = getCsvResultArray();
      const setCSVResult = getSetCsvResult();

      if (await getAllSensorLog(e, 1) === true ) {
        csvResult.forEach((value: any) => {
          worksheet.addRow(value);
        });

        // modelごとに該当するCsvResultのみ初期化
        setCSVResult([]);

        csvResult.length = 0;

        console.log("Row Count:" + worksheet.rowCount)
        setIsLoading(false);

        try {
          const uint8Array = await workbook.csv.writeBuffer();
          const blob = new Blob([uint8Array], { type: 'application/octet-binary' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          setTimeout(()=> {
            a.href = url;
            a.download = "sensorlog_" + model + "_" + getNowDate() +  ".csv"; //フォーマットによってファイル拡張子を変えている
            a.click();
            a.remove();

           
          },1000)
          

          // テキストデータをファイルに書き込む
          //await stream.write(blob);

          // ファイルを閉じる
          //await stream.close();
        } catch (error) {
          alert(error);
        }
      } else {
        setIsLoading(false);
      }
    }

    // getAllSensorLog内
    const getAllSensorLog = async(e: any, pageNo: number) => {
      let ret = true;
      e.preventDefault();
      checkLocoEnv();

      // modelごとにResult配列とset関数を取得
      let csvResult = getCsvResultArray();
      let setCSVResult = getSetCsvResult();

      await axios.get(apiUrl, {
        headers: {
          "Authorization": apiKey,
          "Content-Type": "application/json"
        },
        params: {
          ...(pageNo ? {page: pageNo} : {}),
          ...({per_page: 10000}),
          ...(model ? {model: model} : {}),
          ...(macaddress ? {macaddress: macaddress} : {}),
          ...(rssi_gt ? {rssi_gt: rssi_gt} : {}),
          ...(rssi_lt ? {rssi_lt: rssi_lt} : {}),
          ...(detected_gt ? {detected_gt: detected_gt.replace("T", " ")} : {}),
          ...(detected_lt ? {detected_lt: detected_lt.replace("T", " ")} : {}),
          ...(arrived_gt ? {arrived_gt: arrived_gt.replace("T", " ")} : {}),
          ...(arrived_lt ? {arrivedLt: arrived_lt.replace("T", " ")} : {}),
          ...(sort ? {sort: sort} : {})
        }
      })
      .then(async res => {
        console.log(res);
        if(res.data.code === 400) {
          alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
          return ret = false
        } else if(res.data.code === 401) {
          alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
          return ret = false
        }
        const items = JSON.parse(JSON.stringify(res.data.payload))
        if (items.total > 100000) {
          if (pageNo === 1) {
            let result = window.confirm("10万件を超えるデータは出力出来ません\n10万件までのデータを出力しますか？\n総件数:" + items.total + "\n日付範囲を調整して下さい。")
            if (result === false) {
              return ret = false
            }
          }
        } else {
          setLastPageNo(items.last_page)
        }

        let csvArrayCount = csvResult.length;
        // モデルごとに型を分岐して格納
        switch(model) {
          case "iBS02IR":
            (items.data as any[]).forEach((item) => {
              const value = { ...item, no: items.from } as iBS02IR_ResultType;
              items.from++;
              (csvResult as iBS02IR_ResultType[]).push(value);
            });
            break;
          case "iBS02PIR":
            (items.data as any[]).forEach((item) => {
              const value = { ...item, no: items.from } as iBS02PIR_ResultType;
              items.from++;
              (csvResult as iBS02PIR_ResultType[]).push(value);
            });
            break;
          case "iBS03R":
            (items.data as any[]).forEach((item) => {
              const value = { ...item, no: items.from } as iBS03R_ResultType;
              items.from++;
              (csvResult as iBS03R_ResultType[]).push(value);
            });
            break;
          case "iBS03T":
            (items.data as any[]).forEach((item) => {
              const value = { ...item, no: items.from } as iBS03T_ResultType;
              items.from++;
              (csvResult as iBS03T_ResultType[]).push(value);
            });
            break;
          case "iBS05H":
            (items.data as any[]).forEach((item) => {
              const value = { ...item, no: items.from } as iBS05H_ResultType;
              items.from++;
              (csvResult as iBS05H_ResultType[]).push(value);
            });
            break;
          default:
            alert("モデルを選択して下さい")
            break;
        }
        switch(model) {
          case "iBS02IR":
            setCSVResult([...(csvResult as iBS02IR_ResultType[])]);
            break;
          case "iBS02PIR":
            setCSVResult([...(csvResult as iBS02PIR_ResultType[])]);
            break;
          case "iBS03R":
            setCSVResult([...(csvResult as iBS03R_ResultType[])]);
            break;
          case "iBS03T":
            setCSVResult([...(csvResult as iBS03T_ResultType[])]);
            break;
          case "iBS05H":
            setCSVResult([...(csvResult as iBS05H_ResultType[])]);
            break;
          default:
            setCSVResult([...csvResult]);
            break;
        }
        console.log("lastPageNo:" + lastPageNo)

        if (items.last_page > 10) {
          if (items.current_page !== 10) {
            await getAllSensorLog(e, items.current_page + 1);
          } else {
            console.log("getall: " + csvResult.length);
          }
        } else {
          if (items.current_page !== items.last_page) {
            await getAllSensorLog(e, items.current_page + 1);
          } else {
            console.log("getall: " + csvResult.length);
          }
        }        
      })
      .catch(err => 
        alert("エラーが発生しました。" + err)
      )

      return ret
  }

  const changeDetectedGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00";
    }
    setDetcted_gt(value);
  }

  const changeDetectedLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00";
    }
    setDetcted_lt(value);
  }

  const changeArrivedGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00";
    }
    setArrived_gt(value);
  }

  const changeArrivedLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00";
    }
    setArrived_lt(value);
  }

  const changePerPage = (value: string) => {
    setPer_Page(value)
  }

  const getNowDate = () => {
    let dt = new Date();
    let y = dt.getFullYear();
    let m = ("00" + (dt.getMonth()+1)).slice(-2);
    let d = ("00" + (dt.getDate())).slice(-2);
    let result = y  + m +  d;
    return result;
  }

  const getLastPageNo = () => {
    if (per_page === "") {
      return 100000 / 100
    } else {
      return 100000 / Number(per_page) 
    }
  }

  type sensorParamsType = {
    apikey?: string,
    macaddress?: string,
    model?: string,
    perpage?: string,
    rssigt?: string,
    rssilt?: string,
    detectedgt?: string,
    detectedlt?: string,
    arrivedgt?: string,
    arrivedlt?: string,
    sort?: string
  }

  const saveParams = () => {
    let params: sensorParamsType = {};
    //params.apikey = apiKey ? apiKey : "";
    params.macaddress = macaddress ? macaddress : "";
    params.perpage = per_page ? per_page : "";
    params.model = model ? model : "";
    params.rssigt = rssi_gt ? rssi_gt : "";
    params.rssilt = rssi_lt ? rssi_lt : "";
    params.detectedgt = detected_gt ? detected_gt : "";
    params.detectedlt = detected_lt ? detected_lt : "";
    params.arrivedgt = arrived_gt ? arrived_gt : "";
    params.arrivedlt = arrived_lt ? arrived_lt : "";
    params.sort = sort ? sort : "";

    let json = JSON.stringify(params);
    console.log("params:" + json);
    localStorage.setItem("locoSensorParams", json)

  }

  const saveApikey = () => {
    localStorage.setItem("locoApikey", apiKey ? apiKey : "" );
  }

  const loadParams = () => {
    const paramsJson = localStorage.getItem("locoSensorParams")
    if (paramsJson != null) {
      const params:sensorParamsType = JSON.parse(paramsJson as string)
      //setApikey(params.apikey ? params.apikey : "");
      setPer_Page(params.perpage ? params.perpage : "")
      setModel(params.model ? params.model : "");
      setMacaddress(params.macaddress ? params.macaddress : "");
      setRssi_gt(params.rssigt ? params.rssigt : "");
      setRssi_lt(params.rssilt ? params.rssilt : "");
      setDetcted_gt(params.detectedgt ? params.detectedgt : "");
      setDetcted_lt(params.detectedlt ? params.detectedlt : "");
      setArrived_gt(params.arrivedgt ? params.arrivedgt : "");
      setArrived_lt(params.arrivedlt ? params.arrivedlt : "");
      setSort(params.sort ? params.sort : "");
    }
  }

  const loadApikey = () => {
    const locoApikey = localStorage.getItem("locoApikey")
    if (locoApikey != null) {
      setApikey(locoApikey ? locoApikey : "");
    }
  }

  const setSelectApikey = () => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) {
        const secret = JSON.parse(secretJson as string)

        const selectApikey = document.getElementById("apikey") as HTMLSelectElement;
        const option1 = document.createElement("option");
        option1.value = "";
        option1.textContent = "APIKeyを選択して下さい";
        selectApikey?.appendChild(option1)

        secret.forEach((element: { apikey: string; name: string | null; }) => {
            const option1 = document.createElement("option");
            option1.value = element.apikey;
            option1.textContent = element.name;
            selectApikey?.appendChild(option1)
        })
        
        //setName(secret.name)
        //setApikey(secret.apikey)
    }
}

  useEffect(() => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) {
      setSelectApikey()
    }
    loadParams();
    loadApikey();
  },[])

  return (
    <div>
        <Header current_page="Sensor"/>


      <div className="card">
          <Form className="font-weight-bold" onSubmit={(e) => getSensorLogs(e, 0)}>
              <Form.Group as={Row} className="mx-3">
              <Col xs={12} md={4}>
                <Form.Label>ApiKey</Form.Label>
                <Form.Control as="select" id="apikey" value={apiKey as string} placeholder="ApiKeyを選択" onChange={(e) => setApikey(e.target.value)} />
              </Col>
              <Col xs={12} md={4}>
                <Form.Label>Model</Form.Label>
                <Form.Control
                  as="select"
                  name="model"
                  value={model}
                  onChange={(e) => setModel(e.target.value)}
                >
                  <option value="">モデルを選択してください</option>
                  <option value="iBS02IR">iBS02IR</option>
                  <option value="iBS02PIR">iBS02PIR</option>
                  <option value="iBS03R">iBS03R</option>
                  <option value="iBS03T">iBS03T</option>
                  <option value="iBS05H">iBS05H</option>
                </Form.Control>
              </Col>
              <Col xs={12} md={4}>
                <Form.Label>Per_Page（デフォルト1000件/最大10000件）</Form.Label>
                <Form.Control type="text" name="per_page" value={per_page as string} placeholder="１ページ辺りの最大件数を指定" onChange={(e) => changePerPage(e.target.value)} />
              </Col>
              </Form.Group>
              
            
            
              <Form.Group as={Row} className="mx-3">
              <Col xs={12} md={4}>
                <Form.Label>macaddress</Form.Label>
                <Form.Control type="text" name="macaddress" value={macaddress as string} className="w-27" placeholder="macaddressを入力" onChange={(e) => setMacaddress(e.target.value)} />
              </Col>
              <Col xs={12} md={4}>
                <Form.Label>Rssi_gt（RSSIの値以上を検索）</Form.Label>
                <Form.Control type="text" name="rssi_gt" value={rssi_gt as string} className="w-27" placeholder="RSSIの値（>=）を入力" onChange={(e) => setRssi_gt(e.target.value)} />
              </Col>
              <Col xs={12} md={4}>
                <Form.Label>Rssi_lt（RSSIの値以下を検索）</Form.Label>
                <Form.Control type="text" name="rssi_lt" value={rssi_lt as string} className="w-27" placeholder="RSSIの値（<=）を入力" onChange={(e) => setRssi_lt(e.target.value)} />
              </Col>
              </Form.Group>
              <Form.Group as={Row} className="mx-3">
              <Col xs={12} md={4}>
                <Form.Label>Detected_gt（ビーコン発見時刻以降）</Form.Label>
                <Form.Control type="datetime-local" step="1" autoComplete="on" name="detected_gt" value={detected_gt as string} className="w-27" placeholder="ビーコン発見時の時刻（>=）を入力 [YYYY-mm-dd hh:mm:ss]" onChange={(e) => changeDetectedGt(e.target.value)} />
              </Col>
              <Col xs={12} md={4}>
                <Form.Label>Detected_lt（ビーコン発見時刻以前）</Form.Label>
                <Form.Control type="datetime-local" step="1" name="detected_lt" value={detected_lt as string} className="w-27" placeholder="ビーコン発見時の時刻（<=）を入力 [YYYY-mm-dd hh:mm:ss]" onChange={(e) => changeDetectedLt(e.target.value)} />
              </Col>
              <Col xs={12} md={4}>
                <Form.Label>Arrived_gt（ログのサーバー到達時刻以降）</Form.Label>
                <Form.Control type="datetime-local" step="1" name="arrived_gt" value={arrived_gt as string} className="w-27" placeholder="ビーコンログ到達時の時刻（>=）を入力 [YYYY-mm-dd hh:mm:ss]" onChange={(e) => changeArrivedGt(e.target.value)} />
              </Col>
              </Form.Group>
              <Form.Group as={Row} className="mx-3">
              <Col xs={12} md={4}>
                <Form.Label>Arrived_lt（ログのサーバー到達時刻以前）</Form.Label>
                <Form.Control type="datetime-local" step="1" name="arrived_lt" value={arrived_lt as string} className="w-27" placeholder="ビーコンログ到達時の時刻（<=）を入力 [YYYY-mm-dd hh:mm:ss]" onChange={(e) => changeArrivedLt(e.target.value)} />
              </Col>
              <Col xs={12} md={4}>
                <Form.Label>Sort（デフォルト: DESC（新着順））</Form.Label>     
                <Form.Control as="select" className="w-27" value={sort as string} onChange={e => setSort(e.target.value)} >
                    <option value="">ASC（古い順）またはDESC（新着順）を指定</option>
                    <option value="asc">ASC（古い順）</option>
                    <option value="desc">DESC（新着順）</option>
                </Form.Control>
              </Col>
              </Form.Group>
            <div className="text-center">
              <Form.Group as={Button} type="submit" className="mt-3 mb-2" style={{width: "300px"}}>View SensorLogs</Form.Group>
            </div>
          </Form>
          <Form className="font-weight-bold">
            <div className="text-center">
              <Form.Group as={Button} type="button" id="csvbtn" variant="success" className="mt-3 mb-2" style={{width: "300px"}} onClick={(e) =>  createCSV(e)}>CSV Export</Form.Group>
              <div>
                  <Form.Label>CSV出力の項目に含める</Form.Label> 
                  <label>
                  <input type="checkbox" className='mx-2' onChange={() => setNoCheck(prevState => !prevState)}></input>
                  no</label>
              </div>
            </div>
          </Form>
      </div>
      {(() => {
        if (isLoading) {
          return (
            <div>
              <Loading/>
            </div>
          )
        }
      
      })()}
  
      {(() => {
        if (total >= 0) {
          return (
            <div>
              <p className="mx-4">TotalLogCount:{total}</p>
              <div className="d-flex justify-content-around">     
                <PageSelect pageNo={pageNo} lastPageNo={lastPageNo} getLog={getSensorLogs}></PageSelect>  
              </div>
              {/* 各Result配列の件数で出し分け */}
              {iBS02IRResult.length > 0 && (
                <SensorLog_iBS02IR_Result sensorlogs={iBS02IRResult} />
              )}
              {iBS02PIRResult.length > 0 && (
                <SensorLog_iBS02PIR_Result sensorlogs={iBS02PIRResult} />
              )}
              {iBS03RResult.length > 0 && (
                <SensorLog_iBS03R_Result sensorlogs={iBS03RResult} />
              )}
              {iBS03TResult.length > 0 && (
                <SensorLog_iBS03T_Result sensorlogs={iBS03TResult} />
              )}
              {iBS05HResult.length > 0 && (
                <SensorLog_iBS05H_Result sensorlogs={iBS05HResult} />
              )}
            </div>
          );
        } else {
          return (
            <div>
                {
                    total === 0 && <p className="mx-4">TotalLogCount:{total}</p> 
                }
            </div>
            );
        }
      })()}
    </div>
  )
}

export default SensorLog